<template>
  <div>
    <div class="form-group" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel"> {{label}} </label>
      <input class="form-control" :required="required" v-model="value" :placeholder="placeholder" v-if="!this.area"
             :name="this.data.tag" :type="[this.pass == true ? 'password':'text']"/>
      <textarea class="form-control" :required="required" v-model="value" :placeholder="placeholder"
                v-if="this.area" :name="this.data.tag"></textarea>
      <small class="form-text text-muted" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'InputFieldMailingBoss',
		props: ['label', 'value', 'data', 'area', 'showPlaceholder', 'showLabel', 'pass'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
			required() {
			  if(typeof  this.data.required !== 'undefined'){
                return this.data.required === 'yes';
              }else{
                return true;
              }

			},
		}
	}
</script>
<style scoped>
  textarea {
    resize: none;
  }
</style>
